/* KOLI モーション（2026-08-31／2026-09-01 気泡を個別要素方式に変更）
   気泡の生成＋スクロール出現（セクション・特徴行・使い方・実績・写真）＋成分チップのスタッガー。
   設計方針：
   - 「隠すクラス」はJSが付与する。JS無効環境では何も隠れない（＝全部見える）
   - prefers-reduced-motion では付与自体をやめて即時表示（泡も生成しない）
   - ヒーロー（LCP）は対象外。最初の描画を遅らせない */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  /* ---- 気泡（面レイヤーのアニメはPCで重いため、小さな粒を個別にtransformで飛ばす） ---- */
  var main = document.querySelector('main#MainContent');
  /* ポリシー系ページ（/policies/*）は白ベタ＝泡そのものを作らない（2026-09-01） */
  var isPolicy = main && main.dataset.pageType === 'policy';
  if (main && !isPolicy) {
    var field = document.createElement('div');
    field.className = 'koli-bubblefield';
    field.setAttribute('aria-hidden', 'true');
    var count = Math.max(10, Math.min(22, Math.round(window.innerWidth / 90)));
    for (var i = 0; i < count; i++) {
      var b = document.createElement('span');
      var size = 5 + Math.random() * 11;  /* 5〜16px */
      var dur = 9 + Math.random() * 9;    /* 9〜18s */
      b.style.left = (2 + Math.random() * 96).toFixed(1) + '%';
      b.style.width = size.toFixed(1) + 'px';
      b.style.height = size.toFixed(1) + 'px';
      b.style.animationDuration = dur.toFixed(1) + 's';
      /* 負のdelayで最初から画面のあちこちに散らす（全粒が下から一斉に出るのを防ぐ） */
      b.style.animationDelay = (-Math.random() * dur).toFixed(1) + 's';
      if (i % 3 === 0) b.className = 'koli-bubble--ring';
      field.appendChild(b);
    }
    main.prepend(field);
  }

  /* 効果セクション（ゴールド面）専用の白寄りの泡（2026-09-04）。
     背景の全面泡はゴールド不透明面に覆われて見えないため、セクション内に別途撒く。 */
  /* ゴールド面は効果セクションと「こんな時に」の2つに分かれているが、見た目は1枚の帯。
     どちらにも撒かないと帯の下半分だけ空になる。 */
  if (!isPolicy) {
    document.querySelectorAll('.koli-effect, .koli-usecase.koli-section--gold').forEach(function (effect) {
      var ef = document.createElement('div');
      ef.className = 'koli-effect__bubbles';
      ef.setAttribute('aria-hidden', 'true');
      var ecount = Math.max(8, Math.min(16, Math.round(window.innerWidth / 120)));
      for (var j = 0; j < ecount; j++) {
        var eb = document.createElement('span');
        var esize = 6 + Math.random() * 14;  /* 6〜20px */
        var edur = 10 + Math.random() * 9;   /* 10〜19s */
        eb.style.left = (2 + Math.random() * 96).toFixed(1) + '%';
        eb.style.width = esize.toFixed(1) + 'px';
        eb.style.height = esize.toFixed(1) + 'px';
        eb.style.animationDuration = edur.toFixed(1) + 's';
        eb.style.animationDelay = (-Math.random() * edur).toFixed(1) + 's';
        if (j % 3 === 0) eb.className = 'koli-bubble--ring';
        ef.appendChild(eb);
      }
      effect.prepend(ef);
    });
  }

  var targets = [];

  document.querySelectorAll('.koli .koli-inner').forEach(function (el) {
    if (el.closest('.koli-hero')) return; /* FVは隠さない */
    if (el.closest('.koli-nomotion')) return; /* FAQ・注意など動かさない指定のセクション */
    targets.push(el);
  });

  document.querySelectorAll('.koli-featrow, .koli-step, .koli-brand__photo, .koli-facts li, .koli-effect__scenes li, .koli-stats li').forEach(function (el) {
    targets.push(el);
  });

  document.querySelectorAll('.koli-ingredients li').forEach(function (el, i) {
    el.style.transitionDelay = (i * 45) + 'ms';
    el.classList.add('koli-reveal--pop');
    targets.push(el);
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('koli-inview');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  targets.forEach(function (el) {
    el.classList.add('koli-reveal');
    io.observe(el);
  });
})();
